import { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  doc,
  query,
  orderBy,
  where,
  setDoc,
} from "firebase/firestore";

export default function AdminBusinesses() {
  const [cats, setCats] = useState([]);
  const [rows, setRows] = useState([]);

  const [business_name, setBusinessName] = useState("");
  const [country, setCountry] = useState("Antigua and Barbuda");
  const [island, setIsland] = useState("Antigua");
  const [city, setCity] = useState("");
  const [about_short, setAboutShort] = useState("");
  const [listingTier, setListingTier] = useState("free");
  const [is_published, setPublished] = useState(true);
  const [categoryIds, setCategoryIds] = useState([]);

  async function loadCats() {
    const q = query(
      collection(db, "categories"),
      where("enabled", "==", true),
      orderBy("name")
    );
    const snap = await getDocs(q);
    setCats(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  }

  async function loadRows() {
    const q = query(collection(db, "businesses"), orderBy("business_name"));
    const snap = await getDocs(q);
    setRows(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  }

  useEffect(() => {
    loadCats();
    loadRows();
  }, []);

  function toggleCat(id) {
    setCategoryIds(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  }

  async function createOne() {
    if (!business_name) return;

    const words = about_short.trim().split(/\s+/);
    if (words.length > 60) {
      alert("Description must be 60 words or less");
      return;
    }

    await addDoc(collection(db, "businesses"), {
      business_name,
      country,
      island,
      city,
      about_short: about_short || null,
      listingTier,
      is_published,
      categoryIds,
    });

    setBusinessName("");
    setCity("");
    setAboutShort("");
    setCategoryIds([]);
    setListingTier("free");
    await loadRows();
  }

  async function togglePublish(id, curr) {
    await updateDoc(doc(db, "businesses", id), {
      is_published: !curr,
    });
    await loadRows();
  }

  return (
    <div style={{ maxWidth: 1000, margin: "20px auto" }}>
      <h2>Businesses</h2>

      <div style={{ display:"grid", gap:8, gridTemplateColumns:"1fr 1fr 1fr" }}>
        <input
          placeholder="Business name"
          value={business_name}
          onChange={(e)=>setBusinessName(e.target.value)}
        />
        <input
          placeholder="Island"
          value={island}
          onChange={(e)=>setIsland(e.target.value)}
        />
        <textarea
          placeholder="Short description (60 words max)"
          value={about_short}
          onChange={(e)=>setAboutShort(e.target.value)}
          rows={3}
        />

        <select
          value={listingTier}
          onChange={(e)=>setListingTier(e.target.value)}
        >
          <option value="free">Free</option>
          <option value="basic">Basic</option>
          <option value="featured">Featured</option>
        </select>

        <label>
          <input
            type="checkbox"
            checked={is_published}
            onChange={(e)=>setPublished(e.target.checked)}
          /> Published
        </label>
      </div>

      <div style={{ marginTop: 10 }}>
        <div>Categories</div>
        {cats.map(c => (
          <label key={c.id} style={{ marginRight: 12 }}>
            <input
              type="checkbox"
              checked={categoryIds.includes(c.id)}
              onChange={()=>toggleCat(c.id)}
            /> {c.name}
          </label>
        ))}
      </div>

      <button style={{ marginTop: 12 }} onClick={createOne}>
        Add Business
      </button>

      <div style={{ marginTop: 20 }}>
        {rows.map(r => (
          <div
            key={r.id}
            style={{
              display:"grid",
              gridTemplateColumns:"2fr 1fr 1fr auto",
              gap:8,
              padding:"8px 0",
              borderBottom:"1px solid #eee"
            }}
          >
            <div>{r.business_name}</div>
            <div>{r.listingTier || "free"}</div>
            <div>{r.is_published ? "published" : "draft"}</div>
            <button onClick={()=>togglePublish(r.id, r.is_published)}>
              {r.is_published ? "Unpublish" : "Publish"}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
